<template lang="html">
  <div class="jellap-component">
    <br>
    <v-container>
      <v-form
        ref="diak_jellap_form"
        v-model="valid"
        lazy-validation
      >
      <div class="subtitle-1">Orvosi alkalmassági</div>
      <v-divider></v-divider><br>
      <v-row>
        <v-col cols="12" sm="6" md="3">
          <v-select
            v-model="medical_suitability_group_name"
            :items="medical_suitability_group_options"
            label="Alkalmasság csoportja"
            outlined
            @change="jellap_change = false"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-autocomplete
              v-model="korlatozas_code"
              :items="korlatozasok"
              label="Korlátozások"
              item-text="Kod"
              item-value="Id"
              outlined
              multiple
              chips
              small-chips
              @change="jellap_change = false"
            ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-text-field
          v-model="medical_cert_date"
          label="Érvényesség vége"
          v-mask="'####-##-##'"
          hint="formátum: éééé-hh-nn"
          outlined
          @change="jellap_change = false"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-file-input
              v-model="medCert_to_upload"
              accept=".pdf"
              outlined
              small-chips
              label="Igazolás feltöltése">
          </v-file-input>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="2" class="mt-2">
        <v-btn
          v-if="!orvosi_url || medCert_to_upload"
          color="primary"
          @click="orvosiUpload()"
          rounded
          :disabled="medCert_to_upload == '' || uploading || !jellap_change || !medical_cert_date || !medical_suitability_group_name"
          :loading="uploading"
        >
        feltöltés
        <v-icon right>cloud_upload</v-icon>
        </v-btn>
        <v-btn
          dark
          v-if="orvosi_url && !medCert_to_upload"
          color="green"
          @click="downloadUploadedOrvosi()"
          rounded
        >
        letöltés
        <v-icon right>cloud_download</v-icon>
        </v-btn>
        </v-col>
        <v-col md="2" class="mt-2">
        <v-btn
          v-if="orvosi_url && !medCert_to_upload && pallasz_id"
          color="red"
          @click="hianypot_dialog = true"
          outlined
          :disabled="hianypotlas_loader || !jellap_change"
          :loading="hianypotlas_loader"
        >
        hiánypótlás
        <v-icon right>cloud_upload</v-icon>
        </v-btn>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row>
        <v-col cols="12" sm="6" md="3">
          <v-switch @change="jellap_change = false" v-model="exam_cert" label="Vizsgaigazolás" color="primary"></v-switch>
        </v-col>
        <v-col v-if="exam_cert" cols="12" sm="6" md="3">
          <v-select
            v-model="driving_exam_cert_category"
            :items="category_list"
            item-text="category"
            item-value="category"
            label="Kategória"
            :rules="[rules.required]"
            outlined
            @change="jellap_change = false"
          ></v-select>
        </v-col>
        <v-col v-if="exam_cert" cols="12" sm="6" md="3">
          <v-text-field
          v-model="driving_exam_cert_number"
          label="Vizsgaigazolás száma"
          :rules="[rules.required]"
          outlined
          @change="jellap_change = false"
          ></v-text-field>
        </v-col>
        <v-col v-if="exam_cert" cols="12" sm="6" md="3">
          <v-text-field
          v-model="exam_cert_date"
          label="Vizsga dátuma"
          v-mask="'####-##-##'"
          hint="formátum: éééé-hh-nn"
          :rules="[rules.required]"
          outlined
          @change="jellap_change = false"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-container v-if="nkh_course_type_id == 111 || nkh_course_type_id == 115 || nkh_course_type_id == 117 || nkh_course_type_id == 120">
      <div class="subtitle-1">Felmentések</div>
      <v-divider></v-divider><br>
      <v-container>
        <v-checkbox disabled @change="jellap_change = false" v-model="exempted_bu" class="shrink mr-2 mt-0" label="Biztonsági ellenőrzés és üzemeltetés"></v-checkbox>
        <v-checkbox @change="jellap_change = false" v-model="exempted_m" class="shrink mr-2 mt-0" label="Munkavédelem, tűzvédelem, szállítás"></v-checkbox>
        <v-checkbox @change="jellap_change = false" v-model="exempted_szu" class="shrink mr-2 mt-0" label="Szerkezeti és üzemeltetési ismeretek"></v-checkbox>
        <v-row v-if="exempted_m">
          <v-col cols="12" sm="3" md="3">
            <v-text-field
            v-model="mu_doc_serial_number"
            label="Okirat száma (Mu)"
            :rules="[rules.required]"
            outlined
            @change="jellap_change = false"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="2" md="2">
            <v-text-field
            v-model="mu_doc_issue_date"
            label="Okirat kelte (Mu)"
            v-mask="'####-##-##'"
            hint="formátum: éééé-hh-nn"
            :rules="[rules.required]"
            outlined
            @change="jellap_change = false"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4">
              <v-combobox
                v-model="qualification_mu"
                :items="qualification_list_mu"
                item-text="Megnevezes"
                item-value="Id"
                required
                label="Végzettség típusa (Mu)"
                :rules="[rules.required]"
                outlined
                @change="jellap_change = false"
              ></v-combobox>
            </v-col>
            <v-col cols="12" sm="6" md="3">
            <v-file-input
                v-model="qualification_mu_to_upload"
                accept=".pdf"
                outlined
                small-chips
                :rules="[rules.required]"
                label="Bizonyítvány feltöltése (Mu)">
            </v-file-input>
          </v-col>
        </v-row>
        <v-row v-if="exempted_szu">
          <v-col cols="12" sm="3" md="3">
            <v-text-field
            v-model="exempted_doc_serial_number"
            label="Okirat száma (Szü)"
            :rules="[rules.required]"
            outlined
            @change="jellap_change = false"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="2" md="2">
            <v-text-field
            v-model="exempted_doc_issue_date"
            label="Okirat kelte (Szü)"
            v-mask="'####-##-##'"
            hint="formátum: éééé-hh-nn"
            :rules="[rules.required]"
            outlined
            @change="jellap_change = false"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4">
              <v-combobox
                v-model="qualification_szu"
                :items="qualification_list_szu"
                item-text="Megnevezes"
                item-value="Id"
                required
                label="Végzettség típusa (Szü)"
                :rules="[rules.required]"
                outlined
                @change="jellap_change = false"
              ></v-combobox>
            </v-col>
            <v-col cols="12" sm="6" md="3">
            <v-file-input
                v-model="qualification_szu_to_upload"
                accept=".pdf"
                outlined
                small-chips
                :rules="[rules.required]"
                label="Bizonyítvány feltöltése (Szü)">
            </v-file-input>
          </v-col>
        </v-row>
        <v-row >
          <v-col md="2">
            <v-btn
              color="primary"
              rounded
              :disabled="!valid || pallasz_id_status == 'Sent' || !pallasz_id || qualif_uploading"
              :loading="qualif_uploading"
              @click="validate_felmentes()"
            >
            <span v-if="exempted_m || exempted_szu">Feltöltés a KAV-hoz</span>
            <span v-if="!exempted_m && !exempted_szu">Felmentések törlése (KAV-nál)</span>
            <v-icon right>save</v-icon>
            </v-btn>
            </v-col>
            <v-col cols="12">
            <p v-if="!exempted_m && !exempted_szu">(Hogyha már van feltöltött felmentése a tanulónak, de törölni szeretnénk.)</p>
            <p v-if="!pallasz_id">(A felmetés feltöltése csak a jelentkezési lap feltöltése után , <span style='color:red;'>de még a beküldés előtt</span> lehetséges!)</p>
            </v-col>
        </v-row>
      </v-container>
    </v-container>
      <div class="subtitle-1">Nyilatkozat</div>
      <v-divider></v-divider><br>
      <v-container>
        <v-checkbox @change="jellap_change = false" v-model="first_question" class="shrink mr-2 mt-0" label="Gépjárművezetői vizsgához előírt alapfokú iskolai végzettséggel rendelkezem, egyéb esetben írni, olvasni tudok"></v-checkbox>
        <v-checkbox @change="jellap_change = false" v-model="second_question" class="shrink mr-2 mt-0" label="A közúti járművezetéstől a bíróság, illetve szabálysértési hatóság jogerősen eltiltott"></v-checkbox>
          <v-row v-if="second_question">
            <v-col cols="12" sm="6" md="4">
              <v-combobox
                v-model="second_categories"
                :items="category_list"
                item-text="category"
                required
                label="Eltiltott kategóriák"
                :rules="[rules.required]"
                outlined
                multiple
                @change="jellap_change = false"
              ></v-combobox>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
              v-model="second_start_date"
              label="Eltiltás kezdete"
              v-mask="'####-##-##'"
              hint="formátum: éééé-hh-nn"
              :rules="[rules.required]"
              outlined
              @change="jellap_change = false"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
              v-model="second_end_date"
              label="Eltiltás vége"
              v-mask="'####-##-##'"
              hint="formátum: éééé-hh-nn"
              :rules="[rules.required]"
              outlined
              @change="jellap_change = false"
              ></v-text-field>
            </v-col>
          </v-row>
        <v-checkbox @change="jellap_change = false" v-model="third_question" class="shrink mr-2 mt-0" label="Bíróság kényszergyógyításomat vagy kényszergyógykezelésemet elrendelte"></v-checkbox>
          <v-row v-if="third_question">
            <v-col cols="12" sm="6" md="4">
              <v-text-field
              v-model="third_start_date"
              label="Kezdete"
              v-mask="'####-##-##'"
              hint="formátum: éééé-hh-nn"
              :rules="[rules.required]"
              outlined
              @change="jellap_change = false"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
              v-model="third_end_date"
              label="Vége"
              v-mask="'####-##-##'"
              hint="formátum: éééé-hh-nn"
              :rules="[rules.required]"
              outlined
              @change="jellap_change = false"
              ></v-text-field>
            </v-col>
          </v-row>
        <v-checkbox v-model="fourth_question" class="shrink mr-2 mt-0" label="Hatóság a vezetési jogosultságom szünetelését jogerős és végrehajtható határozattal elrendelte"></v-checkbox>
          <v-row v-if="fourth_question">
            <v-col cols="12" sm="6" md="4">
              <v-text-field
              v-model="fourth_start_date"
              label="Kezdete"
              v-mask="'####-##-##'"
              hint="formátum: éééé-hh-nn"
              :rules="[rules.required]"
              outlined
              @change="jellap_change = false"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
              v-model="fourth_end_date"
              label="Vége"
              v-mask="'####-##-##'"
              hint="formátum: éééé-hh-nn"
              :rules="[rules.required]"
              outlined
              @change="jellap_change = false"
              ></v-text-field>
            </v-col>
          </v-row>
        <v-checkbox @change="jellap_change = false" v-model="fifth_question" class="shrink mr-2 mt-0" label="Bíróság cselekvőképességét kizáró vagy korlátozó gondnokság alá helyezett"></v-checkbox>
        <v-checkbox @change="jellap_change = false" v-model="sixth_question" class="shrink mr-2 mt-0" label="Vezetői engedélyemet hatóság visszavonta"></v-checkbox>
        <v-checkbox @change="jellap_change = false" v-model="seventh_question" class="shrink mr-2 mt-0" label="Egészségi alkalmatlanságomat megállapították"></v-checkbox>
        <v-checkbox @change="jellap_change = false" v-model="eighth_question" class="shrink mr-2 mt-0" label="Bíróság vagy rendőrség a vezetésre jogosító okmányom visszaadását vagy a vezetési jogosultság gyakorlását jártasság igazolásához, új járművezetői vizsgához, egészségi alkalmasság igazolásához vagy pályaalkalmasság igazolásához kötötte"></v-checkbox>
        <v-row v-if="eighth_question">
          <v-col cols="12" sm="6" md="12">
            <p>Ha bíróság vagy rendőrség a vezetésre jogosító okmányom visszaadását vagy a vezetési jogosultság gyakorlását jártasság igazolásához, új járművezetői vizsgához, egészségi alkalmasság igazolásához vagy pályaalkalmasság igazolásához kötötte, akkor ezen kötelezettségemnek eleget tettem</p>
            <v-select
              v-model="eighth_a_question"
              :items="eighth_a_question_items"
              outlined
              @change="jellap_change = false"
            ></v-select>
          </v-col>
        </v-row>
        <v-checkbox @change="jellap_change = false" v-model="nineth_question" class="shrink mr-2 mt-0" label="Utánképzési kötelezettség hatálya alatt állok"></v-checkbox>
        <v-checkbox @change="jellap_change = false" v-model="tenth_question" class="shrink mr-2 mt-0" label="Két éven belül sikertelen közúti gépjárművezetői gyakorlati forgalmi vizsgát tettem a jelentkezési lapon megjelölt vezetői engedély kategóriából"></v-checkbox>
          <v-row v-if="tenth_question">
            <v-col cols="12" sm="6" md="4">
              <v-text-field
              v-model="tenth_place"
              label="Ha igen, hol?"
              :rules="[rules.required]"
              outlined
              @change="jellap_change = false"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
              v-model="tenth_exam_date"
              label="Utolsó vizsga dátuma"
              v-mask="'####-##-##'"
              hint="formátum: éééé-hh-nn"
              :rules="[rules.required]"
              outlined
              @change="jellap_change = false"
              ></v-text-field>
            </v-col>
          </v-row>
        <v-checkbox @change="jellap_change = false" v-model="eleventh_question" class="shrink mr-2 mt-0" label="Elméleti vizsgán a kép- és hangrögzítő eszköz használatához hozzájárulok"></v-checkbox>
        <v-btn
        v-if="pallasz_id"
        color="red"
        @click="nyilatkozatMod()"
        rounded
        outlined
        :disabled="preloader || pallasz_id_status == 'Sent' || !jellap_change || upload_preloader"
        :loading="upload_preloader"
        >
        Új nyilatkozat feltöltés
        <v-icon right>cloud_sync</v-icon>
       </v-btn>
      
      </v-container>
      <v-container v-if="pallasz_id_status != 'Sent' && pallasz_id">
      <div class="subtitle-1">Nyilatkozat (automatikus okmánykiállításhoz)</div>
      <v-divider></v-divider><br>
        <v-checkbox @change="jellap_change = false" v-model="okm_first_question" class="shrink mr-2 mt-0" label="Az automatikus okmánykiállítási eljárást igénylem."></v-checkbox>
        <v-checkbox @change="jellap_change = false" v-model="okm_second_question" class="shrink mr-2 mt-0" label="Külföldi hatóság által kiadott vezetői engedéllyel nem rendelkezem."></v-checkbox>
        <v-checkbox @change="jellap_change = false" v-model="okm_third_question" class="shrink mr-2 mt-0" label="A szokásos tartózkodási helyem Magyarország területén van."></v-checkbox>
        <v-checkbox @change="jellap_change = false" v-model="okm_fourth_question" class="shrink mr-2 mt-0" label="A közlekedésbiztonsági alkalmasságot kizáró okok egyike sem áll fenn."></v-checkbox>
        <v-row>
          <v-col cols="12" md="6">
            <v-select
              v-model="okm_delivery"
              :items="okm_delivery_options"
              label="Okmányátvétel helyének kiválasztása"
              outlined
              @change="jellap_change = false"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6" v-if="okm_delivery == 1">
            <v-autocomplete
              v-model="selected_doc_office"
              :items="document_offices"
              label="Okmányiroda kiválasztása"
              item-text="Megnevezes"
              item-value="Azonosito"
              outlined
              @change="jellap_change = false"
              :rules="[rules.required]"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row v-if="okm_delivery == 4">
          <v-col cols="12" md="4">
            <v-text-field
              v-model="Postcode"
              v-mask="'####'"
              label="Irányítószám"
              outlined
              :rules="[rules.required]"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="8">
            <v-text-field
              v-model="City"
              label="Város"
              outlined
              :rules="[rules.required]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="okm_delivery == 4">
          <v-col cols="12" md="6">
            <v-text-field
              v-model="PublicPremises"
              label="Közterület"
              outlined
              :rules="[rules.required]"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="TypeOfPublicPremises"
              label="Közterület típusa"
              outlined
              :rules="[rules.required]"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="NumberOfHouse"
              label="Közterület száma"
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-checkbox @change="jellap_change = false" v-model="hozzajarulas" class="shrink mr-2 mt-0" label="Hozzájárulok, hogy a Kormányhivatal értesítéseket küldjön."></v-checkbox>
        <v-row v-if="hozzajarulas">
          <v-col cols="12" md="6">
            <v-text-field
              v-model="TajekEmail"
              label="E-mail"
              outlined
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="Phone"
              label="Telefonszám"
              outlined
              disabled
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-btn
            v-if="pallasz_id"
            color="primary"
            rounded
            outlined
            :disabled="preloader || pallasz_id_status == 'Sent' || !jellap_change || upload_preloader"
            :loading="upload_preloader"
            @click="vezEngNyilatkozat()"
            >
            VEN nyilatkozat feltöltés
            <v-icon right>cloud_upload</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" md="6">
            <v-btn
            v-if="pallasz_id"
            color="green"
            rounded
            outlined
            :disabled="preloader || !statement_url || !jellap_change || upload_preloader"
            :loading="upload_preloader"
            @click="venDownload()"
            >
            VEN nyilatkozat letöltés
            <v-icon right>cloud_download</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      </v-container>
        <div class="subtitle-1">Idegen nyelvű vizsga</div>
        <v-divider></v-divider><br>
      <v-container>
        <v-row>
          <v-col cols="12" md="6">
            <v-select
              v-model="szev_nyelv"
              :items="szev_nyelvek"
              label="vizsga nyelve"
              outlined
              @change="jellap_change = false"
              :disabled="pallasz_id_status == 'Sent'"
            ></v-select>
          </v-col>
      </v-row>
      </v-container>
      <v-row>
      <v-col md="2">
      <v-btn
        color="primary"
        @click="validate()"
        rounded
        :disabled="!valid || saveJellapLoader"
        :loading="saveJellapLoader"
      >
      Mentés
      <v-icon right>save</v-icon>
      </v-btn>
      </v-col>
      <v-col md="3">
      <v-btn
        v-if="!pallasz_id"
        color="primary"
        @click="uploadJellap()"
        rounded
        :disabled="preloader || !jellap_change || upload_preloader"
        :loading="upload_preloader"
      >
      Jellap Feltöltés
      <v-icon right>cloud_upload</v-icon>
      </v-btn>
      <v-btn
        v-if="pallasz_id"
        color="primary"
        @click="jellapMod()"
        rounded
        :disabled="preloader || pallasz_id_status == 'Sent' || !jellap_change || upload_preloader"
        :loading="upload_preloader"
      >
      Jellap módosítás
      <v-icon right>cloud_upload</v-icon>
      </v-btn>
      </v-col>
      <v-col md="2">
      <v-btn
        color="primary"
        rounded
        @click="jellapDownload"
        target="_blank"
        :disabled="jellap_error || preloader || !pallasz_id || !jellap_change"
        :loading="download_preloader"
      >
      Letöltés
      <v-icon right>cloud_download</v-icon>
      </v-btn>
      </v-col>
      <v-col md="2">
      <v-btn
        v-if="pallasz_id_status != 'Sent'"
        class="white--text"
        color="red"
        rounded
        @click="adatszolg_dialog = true"
        :disabled="jellap_error || preloader || !pallasz_id || !jellap_change || pallasz_id_status == 'Sent'"
        :loading="send_preloader"
      >
      Beküldés
      <v-icon right>apartment</v-icon>
      </v-btn>
      <v-btn
        v-if="pallasz_id_status == 'Sent'"
        class="white--text"
        color="green"
        rounded
        @click="checkAdatlapIktat()"
        :disabled="send_preloader"
        :loading="send_preloader"
      >
      Ellenőrzés
      <v-icon right>apartment</v-icon>
      </v-btn>
      </v-col>
      <v-col md="3">
      <v-btn
        v-if="pallasz_id_status != 'Sent' && admin"
        class="white--text"
        color="red"
        outlined
        @click="bekuldStatusz()"
        :disabled="jellap_error || preloader || !pallasz_id || !jellap_change || pallasz_id_status == 'Sent'"
        :loading="send_preloader"
      >
      Beküldöttre állít
      </v-btn>
      </v-col>
      </v-row>
      <p v-if="pallasz_id_status == 'Sent'">Az adatlap már beküldésre került a KAV-hoz, ezért nem módosítható!</p>
      <v-row>
        <v-col cols="12" md="4">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="purple"
                outlined
                rounded
                v-bind="attrs"
                v-on="on"
                :disabled="training_type == 'ClassRoom'"
              >
                Ügyfélkapu
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                @click="vd_dialog = true"
                :disabled="pallasz_id && training_type == 'ClassRoom'"
              >
                <v-list-item-title>Küldés</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="checkUgyfelkapu()"
              >
                <v-list-item-title>Befogadás</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
        <v-col cols="12" md="3">
          <v-btn
            v-if="pallasz_id"
            color="red"
            @click="new_jellap_dialog = true"
            rounded
            outlined
            :disabled="preloader || new_upload_loader || !jellap_change || training_type == 'ClassRoom'"
            :loading="new_upload_loader"
          >
          Újra Feltöltés
          <v-icon right>cloud_sync</v-icon>
          </v-btn>
        </v-col>
      <v-col cols="12" md="3">
      <v-btn
        color="primary"
        rounded
        :href="statement_url"
        target="_blank"
        disabled
      >
      Nyilatkozat letöltés
      </v-btn>
      </v-col>
      </v-row>
      </v-form>
    </v-container>
    <v-snackbar v-model="jellap_upload_snackbar" bottom>
      {{ jellap_warning }}
      {{ jellap_error }}
      {{ jellap_success }}
      {{ jellap_faultstring }}
      <v-btn color="pink" text @click="jellap_upload_snackbar = false">
        Bezár
      </v-btn>
    </v-snackbar>

    <v-snackbar v-model="save_result_snackbar" bottom>
      {{ save_result }}
      <v-btn color="pink" text @click="save_result_snackbar = false">
        Bezár
      </v-btn>
    </v-snackbar>

    <v-dialog
      v-model="adatszolg_dialog"
      width="500"
    >
      <v-card>

        <v-card-text class="subtitle-1">
        <v-container>
          Biztosan beküldi az adatlapot?<br>
          (A jelentkezési lap a hatósági beküldést követően nem módosítható!)
        </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            text
            @click="adatszolg_dialog = false"
          >
            Mégsem
          </v-btn>
          <v-btn
            color="green"
            text
            @click="bekuldJellap()"
          >
            Beküldés
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="hianypot_dialog"
      width="500"
    >
      <v-card>

        <v-card-text class="subtitle-1">
        <v-container>
          Biztosan beküldi a hiánypótlást?<br>
        </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            text
            @click="hianypot_dialog = false"
          >
            Mégsem
          </v-btn>
          <v-btn
            color="green"
            text
            @click="orvosiHianypotlas()"
            :disabled="hianypotlas_loader"
            :loading="hianypotlas_loader"
          >
            Beküldés
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="new_jellap_dialog"
      width="500"
    >
      <v-card>

        <v-card-text class="subtitle-1">
        <v-container>
          Biztosan újraküldi az adatlapot?<br>
          (Ilyen esetben újra alá kell írnia azt a tanulónak!)
        </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            text
            @click="new_jellap_dialog = false"
          >
            Mégsem
          </v-btn>
          <v-btn
            color="green"
            text
            @click="uploadJellapNew()"
          >
            Feltöltés
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="vd_dialog"
      width="500"
    >
      <v-card>

        <v-card-text class="subtitle-1">
        <v-container>
          Biztosan elküldi az üzenetet?
        </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            text
            @click="vd_dialog = false, vd_price = null"
          >
            Mégsem
          </v-btn>
          <v-btn
            color="green"
            text
            @click="sendJellap(), vd_dialog = false"
          >
            Küldés
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="ugyfelkapu_dialog"
      width="800"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Jelentkezési lap kiválasztása
        </v-card-title>

        <v-card-text>
          <v-data-table
            v-model="selected_uf_student"
            :headers="uf_header"
            :items="uf_students"
            :items-per-page="5"
            hide-default-footer
            single-select
            show-select
          ></v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            color="red"
            text
            @click="ugyfelkapu_dialog = false"
          >
            bezár
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="selected_uf_student == ''"
            color="green"
            text
            @click="saveUgyfelkapu()"
          >
            átemel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import store from '../store'

import {
  mapFields
} from 'vuex-map-fields'

  export default {
    data () {
      return {
        rules: {
            required: value => !!value || 'Kötelező mező!',
        },
        valid: true,
        medical_suitability_group_name: '',
        medical_suitability_group_options: [
          { text: '', value: null},
          { text: 'I. csoport', value: '1'},
          { text: 'II. csoport', value: '2'},
        ],
        medical_suitability_group_code: [],
        pav_suitability_category: 'Nincs',
        pav_suitability_options: [
          { text: 'Nincs', value: 'Nincs'},
          { text: 'PÁV I.', value: 'Pav1'},
          { text: 'PÁV II.', value: 'Pav2'},
          { text: 'PÁV III.', value: 'Pav3'},
          { text: 'PÁV IV.', value: 'Pav4'},
        ],
        eighth_a_question_items: [
          { text: 'Igen', value: true},
          { text: 'Nem', value: false},
        ],
        exam_cert: false,
        driving_exam_cert_category: '',
        driving_exam_cert_number: '',
        category_list: '',
        eighth_a_question: null,
        eighth_question: false,
        eleventh_question: true,
        fifth_question: false,
        first_question: true,
        fourth_question: false,
        fourth_start_date: null,
        fourth_end_date: null,
        nineth_question: false,
        second_question: false,
        second_categories: null,
        second_start_date: null,
        second_end_date: null,
        seventh_question: false,
        sixth_question: false,
        tenth_question: false,
        tenth_place: null,
        tenth_exam_date: null,
        third_question: false,
        third_start_date: null,
        third_end_date: null,
        exempted_doc_issue_date: null,
        exempted_doc_serial_number: null,
        exempted_bu: false,
        exempted_m: false,
        exempted_szu: false,
        jellap_url: "",
        statement_url: '',
        jellap_warning: null,
        jellap_error: null,
        jellap_success: null,
        jellap_faultstring: null,
        jellap_upload_snackbar: false,
        save_result: null,
        save_result_snackbar: false,
        jellap_change: true,
        okm_first_question: true,
        okm_second_question: true,
        okm_third_question: true,
        okm_fourth_question: true,
        okm_delivery: 3,
        okm_delivery_options: [
          { text: 'Postázás lakóhelyre', value: 2},
          { text: 'Postázás tartózkodási helyre', value: 3},
          { text: 'Postázás egyéb belföldi postacímre', value: 4},
          { text: 'Átvétel kormányablakban/okmányirodában', value: 1},
        ],
        szev_nyelvek: [
          { text: '-', value: null},
          { text: 'Angol', value: 7},
          { text: 'Német', value: 5},
          { text: 'Román', value: 6},
          { text: 'Kínai', value: 4},
        ],
        szev_nyelv: '',
        document_offices: [],
        selected_doc_office: '',
        Addressee: '',
        Postcode: '',
        City: '',
        PublicPremises: '',
        TypeOfPublicPremises: '',
        NumberOfHouse: '',
        AddresseeDescription: '',
        TajekEmail: '',
        Phone: '',
        hozzajarulas: true,
        vd_dialog: false,
        vd_price: '',
        jellap_sent: '',
        pallasz_id: '',
        exam_cert_date: '',
        upload_preloader: false,
        download_preloader: false,
        send_preloader: false,
        pallasz_id_status: '',
        adatszolg_dialog: false,
        new_jellap_dialog: false,
        new_upload_loader: false,
        medical_cert_date: '',
        korlatozasok: [],
        korlatozas_code: [],
        medCert_to_upload: [],
        uploading: false,
        orvosi_url: '',
        saveJellapLoader: false,
        ugyfelkapu_dialog: false,
        uf_students: [],
        selected_uf_student: [],
        uf_header: [
          { text: 'Név', value: 'TanuloNeve' },
          { text: 'Születési idő', value: 'SzuletesiIdo'},
          { text: 'Anyja neve', value: 'AnyjaNeve'},
          { text: 'Kategória', value: 'KepzesNeve'},
        ],
        hianypotlas_loader: false,
        hianypot_dialog: false,
        qualification_szu: '',
        qualification_list_szu: [],
        qualification_mu: '',
        qualification_list_mu: [],
        qualification_szu_to_upload: [],
        qualification_mu_to_upload: [],
        qualif_uploading: false,
        mu_doc_serial_number: '',
        mu_doc_issue_date: '',

      }
    },
    methods: {
      getJellapDetails: async function() {
        store.state.showing.preloader = true
        this.driving_exam_cert_category = '';
        this.exam_cert_date = '';
        await this.gettoken()
        this.$http.post('/diakok/jellap_details_20250213', {
          token: this.token,
          customer_id: this.customer_id,
          course_id: this.course_id,
        }).then((response) => {
          store.state.showing.preloader = false
          this.medical_suitability_group_name = response.data['med_group'][0]['medical_suitability_group_name']
          this.korlatozas_code = response.data['med_group'][0]['medical_suitability_group_code']
          this.medical_cert_date = response.data['med_group'][0]['medical_suitability_ervenyes']
          this.pav_suitability_category = response.data['med_group'][0]['pav_suitability_category']
          this.TajekEmail = response.data['contacts'][0]['email1']
          this.Phone = response.data['contacts'][0]['phone1']
          this.driving_exam_cert_category = response.data['jellap_form'][0]['driving_exam_cert_category']
          this.driving_exam_cert_number = response.data['jellap_form'][0]['driving_exam_cert_number']
          this.exam_cert_date = response.data['jellap_form'][0]['exam_cert_date']
          this.eighth_a_question = response.data['jellap_form'][0]['eighth_a_question']
          this.eighth_question = response.data['jellap_form'][0]['eighth_question']
          this.eleventh_question = response.data['jellap_form'][0]['eleventh_question']
          this.fifth_question = response.data['jellap_form'][0]['fifth_question']
          this.first_question = response.data['jellap_form'][0]['first_question']
          this.fourth_question = response.data['jellap_form'][0]['fourth_question']
          this.nineth_question = response.data['jellap_form'][0]['nineth_question']
          this.second_question = response.data['jellap_form'][0]['second_question']
          this.seventh_question = response.data['jellap_form'][0]['seventh_question']
          this.sixth_question = response.data['jellap_form'][0]['sixth_question']
          this.tenth_question = response.data['jellap_form'][0]['tenth_question']
          this.third_question = response.data['jellap_form'][0]['third_question']
          this.second_categories = response.data['jellap_form'][1]
          this.second_start_date = response.data['jellap_form'][0]['second_start_date']
          this.second_end_date = response.data['jellap_form'][0]['second_end_date']
          this.fourth_start_date = response.data['jellap_form'][0]['fourth_start_date']
          this.fourth_end_date = response.data['jellap_form'][0]['fourth_end_date']
          this.third_start_date = response.data['jellap_form'][0]['third_start_date']
          this.third_end_date = response.data['jellap_form'][0]['third_end_date']
          this.tenth_place = response.data['jellap_form'][0]['tenth_place']
          this.tenth_exam_date = response.data['jellap_form'][0]['tenth_exam_date']
          this.exempted_doc_issue_date = response.data['jellap_form'][0]['exempted_doc_issue_date']
          this.exempted_doc_serial_number = response.data['jellap_form'][0]['exempted_doc_serial_number']
          this.qualification_szu = response.data['jellap_form'][0]['exempted_szu_qualification']
          this.mu_doc_issue_date = response.data['jellap_form'][0]['exempted_mu_issue_date']
          this.mu_doc_serial_number = response.data['jellap_form'][0]['exempted_mu_serial_number']
          this.qualification_mu = response.data['jellap_form'][0]['exempted_mu_qualification']
          this.exempted_bu = response.data['jellap_form'][0]['exempted_bu']
          this.exempted_m = response.data['jellap_form'][0]['exempted_m']
          this.exempted_szu = response.data['jellap_form'][0]['exempted_szu']
          this.okm_first_question = response.data['jellap_form'][0]['okm_first_question']
          this.okm_second_question = response.data['jellap_form'][0]['okm_second_question']
          this.okm_third_question = response.data['jellap_form'][0]['okm_third_question']
          this.okm_fourth_question = response.data['jellap_form'][0]['okm_fourth_question']
          this.selected_doc_office = response.data['jellap_form'][0]['selected_doc_office']
          this.Addressee = response.data['jellap_form'][0]['addressee']
          this.Postcode = response.data['jellap_form'][0]['postcode']
          this.City = response.data['jellap_form'][0]['city']
          this.PublicPremises = response.data['jellap_form'][0]['publicpremises']
          this.TypeOfPublicPremises = response.data['jellap_form'][0]['typeofpublicpremises']
          this.AddresseeDescription = response.data['jellap_form'][0]['addresseedescription']
          this.NumberOfHouse = response.data['jellap_form'][0]['numberofhouse']
          this.hozzajarulas = response.data['jellap_form'][0]['hozzajarulas']
          this.okm_delivery = parseInt(response.data['jellap_form'][0]['okm_delivery'])
          this.jellap_sent = response.data['jellap_form'][0]['email_sent']
          this.szev_nyelv = response.data['jellap_form'][0]['szev_nyelv']
        }, (error) => {
          console.log(error.data);
        })
      },
      saveJellapDetails: async function() {
        this.saveJellapLoader = true
        await this.gettoken()
        this.$http.post('/diakok/save_jellap_details_20250213', {
          token: this.token,
          customer_id: this.customer_id,
          course_id: this.course_id,
          course_student_id: this.course_student_id,
          customer_name: this.full_name,
          course_data_id: this.course_data_id,
          medical_suitability_group_name: this.medical_suitability_group_name,
          medical_suitability_group_code: this.korlatozas_code,
          medical_cert_date: this.medical_cert_date,
          pav_suitability_category: this.pav_suitability_category,
          driving_exam_cert_category: this.driving_exam_cert_category,
          driving_exam_cert_number: this.driving_exam_cert_number,
          eighth_a_question: this.eighth_a_question,
          eighth_question: this.eighth_question,
          eleventh_question: this.eleventh_question,
          fifth_question: this.fifth_question,
          first_question: this.first_question,
          fourth_question: this.fourth_question,
          nineth_question: this.nineth_question,
          second_question: this.second_question,
          seventh_question: this.seventh_question,
          sixth_question: this.sixth_question,
          tenth_question: this.tenth_question,
          third_question: this.third_question,
          second_categories: this.second_categories,
          second_start_date: this.second_start_date,
          second_end_date: this.second_end_date,
          fourth_start_date: this.fourth_start_date,
          fourth_end_date: this.fourth_end_date,
          third_start_date: this.third_start_date,
          third_end_date: this.third_end_date,
          tenth_place: this.tenth_place,
          tenth_exam_date: this.tenth_exam_date,
          exempted_doc_issue_date: this.exempted_doc_issue_date,
          exempted_doc_serial_number: this.exempted_doc_serial_number,
          qualification_szu: this.qualification_szu,
          mu_doc_issue_date: this.mu_doc_issue_date,
          mu_doc_serial_number: this.mu_doc_serial_number,
          qualification_mu: this.qualification_mu,
          exempted_bu: this.exempted_bu,
          exempted_m: this.exempted_m,
          exempted_szu: this.exempted_szu,
          okm_first_question: this.okm_first_question,
          okm_second_question: this.okm_second_question,
          okm_third_question: this.okm_third_question,
          okm_fourth_question: this.okm_fourth_question,
          okm_delivery: this.okm_delivery,
          selected_doc_office: this.selected_doc_office,
          Addressee: this.Addressee,
          Postcode: this.Postcode,
          City: this.City,
          PublicPremises: this.PublicPremises,
          TypeOfPublicPremises: this.TypeOfPublicPremises,
          NumberOfHouse: this.NumberOfHouse,
          AddresseeDescription: this.AddresseeDescription,
          hozzajarulas: this.hozzajarulas,
          exam_cert_date: this.exam_cert_date,
          szev_nyelv: this.szev_nyelv
        }).then((response) => {
          this.saveJellapLoader = false
          this.save_result = response.data
          this.save_result_snackbar = true

          this.getJellapDetails();
          if (this.jellap_url) {
            this.uploadJellap()
          }
        }, (error) => {
          this.saveJellapLoader = false
          console.log(error.data);
        })
      },
      getCategoryList() {
        store.state.showing.preloader = true
        this.$http.get('/wsdl/dlcategory'
        ).then((response) => {
          store.state.showing.preloader = false
          this.category_list = response.data

        }, (error) => {
          console.log(error.data);
        })
      },
      getKorlatozasList() {
        this.$http.get('/kokeny/korlatozasok'
        ).then((response) => {
          this.korlatozasok = response.data
        }, (error) => {
          console.log(error.data);
        })
      },
      uploadJellap: async function() {
        store.state.showing.preloader = true
        this.upload_preloader = true;
        await this.gettoken()
        this.$http.post('/kokeny/adatlap_upload_250226', {
          token: this.token,
          customer_id: this.customer_id,
          course_id: this.course_id,
          contract_id: this.contract_id,
          course_student_id: this.course_student_id,
          pallasz_id: this.pallasz_id,
          course_data_id: this.course_data_id
        }).then((response) => {
          store.state.showing.preloader = false
          this.upload_preloader = false;
          console.log(response.data);
          this.jellap_success = response.data['message'];
          this.jellap_upload_snackbar = true
          this.pallasz_id = response.data['id'];
          this.downloadJellapUrl();
        }, (error) => {
          store.state.showing.preloader = false
          this.upload_preloader = false;
          console.log(error.data);
        })
      },
      uploadJellapNew: async function() {
        this.new_upload_loader = true;
        this.new_jellap_dialog = false;
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/kokeny/adatlap_upload_250226', {
          token: this.token,
          customer_id: this.customer_id,
          course_id: this.course_id,
          contract_id: this.contract_id,
          course_student_id: this.course_student_id,
          pallasz_id: this.pallasz_id,
          course_data_id: this.course_data_id,
          reload: 'reupload'
        }).then((response) => {
          this.new_upload_loader = false;
          store.state.showing.preloader = false
          console.log(response.data);
          this.jellap_success = response.data['message'];
          this.jellap_upload_snackbar = true
          this.pallasz_id = response.data['id'];
          this.downloadJellapUrl()
        }, (error) => {
          console.log(error.data);
        })
      },
      jellapMod: async function() {
        store.state.showing.preloader = true
        this.upload_preloader = true;
        await this.gettoken()
        this.$http.post('/kokeny/adatlap_mod_231007', {
          token: this.token,
          customer_id: this.customer_id,
          course_id: this.course_id,
          contract_id: this.contract_id,
          course_student_id: this.course_student_id,
          pallasz_id: this.pallasz_id,
          course_data_id: this.course_data_id
        }).then((response) => {
          store.state.showing.preloader = false
          this.upload_preloader = false;
          console.log(response.data);
          this.jellap_success = response.data['message'];
          this.jellap_upload_snackbar = true
          //this.downloadStatementUrl()
          //this.jellapOrvosi();
          this.downloadJellapUrl()
        }, (error) => {
          console.log(error.data);
        })
      },
      nyilatkozatMod: async function() {
        store.state.showing.preloader = true
        this.upload_preloader = true;
        await this.gettoken()
        this.$http.post('/kokeny/nyilatkozat_mod', {
          token: this.token,
          customer_id: this.customer_id,
          course_id: this.course_id,
          contract_id: this.contract_id,
          course_student_id: this.course_student_id,
          pallasz_id: this.pallasz_id,
          course_data_id: this.course_data_id
        }).then((response) => {
          store.state.showing.preloader = false
          this.upload_preloader = false;
          console.log(response.data);
          this.jellap_success = response.data['message'];
          this.jellap_upload_snackbar = true
          this.downloadJellapUrl()
        }, (error) => {
          store.state.showing.preloader = false
          this.upload_preloader = false;
          console.log(error.data);
        })
      },
      vezEngNyilatkozat: async function() {
        store.state.showing.preloader = true
        this.upload_preloader = true;
        await this.gettoken()
        this.$http.post('/kokeny/VEN_nyilatkozat', {
          token: this.token,
          customer_id: this.customer_id,
          course_id: this.course_id,
          contract_id: this.contract_id,
          course_student_id: this.course_student_id,
          pallasz_id: this.pallasz_id,
          course_data_id: this.course_data_id
        }).then((response) => {
          store.state.showing.preloader = false
          this.upload_preloader = false;
          console.log(response.data);
          this.jellap_success = response.data['message'];
          this.jellap_upload_snackbar = true
          this.downloadStatementUrl()
        }, (error) => {
          store.state.showing.preloader = false
          this.upload_preloader = false;
          console.log(error.data);
        })
      },
      jellapOrvosi: async function() {
        store.state.showing.preloader = true
        this.upload_preloader = true;
        await this.gettoken()
        this.$http.post('/kokeny/orvosi_upload_kav', {
          token: this.token,
          customer_id: this.customer_id,
          course_id: this.course_id,
          contract_id: this.contract_id,
          course_student_id: this.course_student_id,
          pallasz_id: this.pallasz_id,
          course_data_id: this.course_data_id
        }).then((response) => {
          store.state.showing.preloader = false
          this.upload_preloader = false;
          console.log(response.data);
          this.jellap_success = response.data['message'];
          this.jellap_upload_snackbar = true
          //this.downloadStatementUrl()
          //this.downloadJellapUrl()
        }, (error) => {
          console.log(error.data);
        })
      },
      bekuldJellap: async function() {
        this.adatszolg_dialog = false;
        store.state.showing.preloader = true
        this.send_preloader = true;
        await this.gettoken()
        this.$http.post('/kokeny/adatlap_bekuld_250220', {
          token: this.token,
          customer_id: this.customer_id,
          course_id: this.course_id,
          contract_id: this.contract_id,
          course_student_id: this.course_student_id,
          pallasz_id: this.pallasz_id,
          course_data_id: this.course_data_id,
          szev_nyelv: this.szev_nyelv
        }).then((response) => {
          this.downloadJellapUrl()
          store.state.showing.preloader = false
          this.send_preloader = false;
          this.jellap_success = response.data['message'];
          this.jellap_upload_snackbar = true
          console.log(response.data);
        }, (error) => {
          console.log(error.data);
        })
      },
      bekuldStatusz: async function() {
        if (confirm("Biztosan elvégzi a műveletet?") == true) {
        this.adatszolg_dialog = false;
        store.state.showing.preloader = true
        this.send_preloader = true;
        await this.gettoken()
        this.$http.post('/kokeny/adatlap_bekuld_statusz', {
          token: this.token,
          pallasz_id: this.pallasz_id
        }).then((response) => {
          this.downloadJellapUrl()
          store.state.showing.preloader = false
          this.send_preloader = false;
          this.jellap_success = response.data['message'];
          this.jellap_upload_snackbar = true
          console.log(response.data);
        }, (error) => {
          console.log(error.data);
        })
        }
      },
      jellapDownload: async function() {
        this.preloader = true
        this.download_preloader = true;
        await this.gettoken()
        this.$http.post('/kokeny/adatlap_print', {
          token: this.token,
          course_data_id: this.course_data_id,
          contract_id: this.contract_id,
        }, {responseType: 'blob'}).then((response) => {
          this.preloader = false
          this.download_preloader = false;
          //Create a Blob from the PDF Stream
          const file = new Blob(
          [response.data],
          {type: 'application/pdf'});
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          window.open(fileURL);
        }, (error) => {
          this.error_text = error.data
        })
      },
      venDownload: async function() {
        this.preloader = true
        this.download_preloader = true;
        await this.gettoken()
        this.$http.post('/kokeny/ven_print', {
          token: this.token,
          course_data_id: this.course_data_id,
          contract_id: this.contract_id,
        }, {responseType: 'blob'}).then((response) => {
          this.preloader = false
          this.download_preloader = false;
          //Create a Blob from the PDF Stream
          const file = new Blob(
          [response.data],
          {type: 'application/pdf'});
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          window.open(fileURL);
        }, (error) => {
          this.error_text = error.data
        })
      },
      downloadJellapUrl: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/jellap_download_230918', {
          token: this.token,
          customer_id: this.customer_id,
          course_id: this.course_id,
          contract_id: this.contract_id,
        }).then((response) => {
          store.state.showing.preloader = false
          this.pallasz_id = response.data['kokeny_id'];
          this.pallasz_id_status = response.data['reg_form_status'];
        }, (error) => {
          console.log(error.data);
        })
      },
      checkAdatlapIktat: async function() {
        this.send_preloader = true
        await this.gettoken()
        this.$http.post('/diakok/jellap_status', {
          token: this.token,
          customer_id: this.customer_id,
          course_id: this.course_id,
          contract_id: this.contract_id,
        }).then((response) => {
          this.send_preloader = false
          this.save_result = response.data;
          this.save_result_snackbar = true;
        }, (error) => {
          this.send_preloader = false
          console.log(error.data);
        })
      },
      downloadStatementUrl: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/statement_download', {
          token: this.token,
          customer_id: this.customer_id,
          course_id: this.course_id,
          contract_id: this.contract_id,
        }).then((response) => {
          store.state.showing.preloader = false
          this.statement_url = response.data
        }, (error) => {
          console.log(error.data);
        })
      },
      getDocOffices: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/kokeny/okmanyirodak', {
          token: this.token
        }).then((response) => {
          this.document_offices = response.data
        }, (error) => {
          console.log(error.data);
        })
      },
      downloadJellap: async function() {
        this.dots_loading = true
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/jellap_download_new', {
          token: this.token,
          customer_id: this.customer_id,
          course_id: this.course_id,
          contract_id: this.contract_id
        }, {responseType: 'blob'}).then((response) => {
          this.dots_loading = false
          this.preloader = false
          //Create a Blob from the PDF Stream
          const file = new Blob(
          [response.data],
          {type: 'application/pdf'});
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          window.open(fileURL);
        }, (error) => {
          this.error_text = error.data
        })
      },
      sendJellap: async function() {
        this.dots_loading = true
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/jellap_send_20230904', {
          token: this.token,
          customer_id: this.customer_id,
          course_id: this.course_id,
          contract_id: this.contract_id
        }).then((response) => {
          this.dots_loading = false
          this.preloader = false
          this.save_result = response.data['message']
          this.save_result_snackbar = true
        }, (error) => {
          console.log(error.data);
        })
      },
      orvosiUpload: async function() {
        this.uploading = true
        // objektummá alakítjuk, mert a funkció több fájl feltöltésére lett írva alapvetően
        this.medCert_to_upload = [this.medCert_to_upload];

        let formData = new FormData();

        for( var i = 0; i < this.medCert_to_upload.length; i++ ){
          let file = this.medCert_to_upload[i];
          formData.append('files[' + i + ']', file);
        }

        formData.append('token', this.token);
        formData.append('contract_id', this.contract_id);

        console.log(formData);
        console.log(this.medCert_to_upload);
        
        await this.gettoken()
        this.$http.post('/kokeny/orvosi_upload',
          formData,
					{
						headers: {
								'Content-Type': 'multipart/form-data'
						}
					}).then((response) => {
            this.uploading = false
            //this.checkUploadedFile()
            //this.response_success = response.data['result'];
            this.jellap_upload_snackbar = true
            this.jellap_success = response.data['message'];
            this.checkUploadedFile()
          console.log(response.data);
        }, (error) => {
          this.uploading = false
          console.log(error.data);
        })
        
      },
      checkUploadedFile: async function() {
        this.medCert_to_upload = null;
        this.orvosi_url = null;
        await this.gettoken()
        this.$http.post('/kokeny/orvosi_upload_check', {
          token: this.token,
          contract_id: this.contract_id
        }).then((response) => {
          this.orvosi_url = response.data[0]['orvosi_url'];
        }, (error) => {
          console.log(error.data);
        })
      },
      downloadUploadedOrvosi: async function() {
        //this.downloading = true
        await this.gettoken()
        this.$http.post('/kokeny/orvosi_download', {
          token: this.token,
          contract_id: this.contract_id,
          orvosi_url: this.orvosi_url
        }, {responseType: 'blob'}).then((response) => {
          //this.downloading = false
          console.log(response.data);
          const extension = this.orvosi_url.split(".");
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', this.full_name+'_orvosi_up.'+extension[1]);
          document.body.appendChild(link);
          link.click();
        }, (error) => {
          this.error_text = error.data
        })
      },
      orvosiHianypotlas: async function() {
        this.hianypotlas_loader = true;
        await this.gettoken()
        this.$http.post('/kokeny/orvosi_hianypotlas_240425', {
          token: this.token,
          customer_id: this.customer_id,
          contract_id: this.contract_id,
          pallasz_id: this.pallasz_id,
        }).then((response) => {
          this.hianypot_dialog = false;
          this.hianypotlas_loader = false;
          this.save_result = response.data;
          this.save_result_snackbar = true;
        }, (error) => {
          this.hianypotlas_loader = false;
          console.log(error.data);
        })
      },
      checkUgyfelkapu: async function() {
        this.uf_students = [];
        this.selected_uf_student = [];
        await this.gettoken()
        this.$http.post('/kokeny/ugyfelkapu_check', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          course_id: this.course_id
        }).then((response) => {
          this.uf_students = response.data;
          this.ugyfelkapu_dialog = true;
          console.log(response.data);
        }, (error) => {
          console.log(error.data);
        })
      },
      getQualifications: async function() {
        await this.gettoken()
        this.$http.post('/kokeny/qualifications', {
          token: this.token,
          contract_id: this.contract_id
        }).then((response) => {
          this.qualification_list_szu = response.data['szu_qualifications'];
          this.qualification_list_mu = response.data['mu_qualifications'];
        }, (error) => {
          console.log(error.data);
        })
      },
      uploadQualification: async function() {
        this.qualif_uploading = true
        // objektummá alakítjuk, mert a funkció több fájl feltöltésére lett írva alapvetően
        this.qualification_szu_to_upload = [this.qualification_szu_to_upload];
        this.qualification_mu_to_upload = [this.qualification_mu_to_upload];

        let formData = new FormData();

        for( var i = 0; i < this.qualification_szu_to_upload.length; i++ ){
          let file_szu = this.qualification_szu_to_upload[i];
          formData.append('file_szu[' + i + ']', file_szu);
        }

        for( var i = 0; i < this.qualification_mu_to_upload.length; i++ ){
          let file_mu = this.qualification_mu_to_upload[i];
          formData.append('file_mu[' + i + ']', file_mu);
        }

        formData.append('token', this.token);
        formData.append('contract_id', this.contract_id);
        formData.append('customer_id', this.customer_id);
        formData.append('pallasz_id', this.pallasz_id);
        formData.append('exempted_szu', this.exempted_szu);
        formData.append('exempted_m', this.exempted_m);
        formData.append('qualification_szu', this.qualification_szu);
        formData.append('exempted_doc_serial_number', this.exempted_doc_serial_number);
        formData.append('exempted_doc_issue_date', this.exempted_doc_issue_date);
        formData.append('qualification_mu', this.qualification_mu);
        formData.append('mu_doc_serial_number', this.mu_doc_serial_number);
        formData.append('mu_doc_issue_date', this.mu_doc_issue_date);
        
        await this.gettoken()
        this.$http.post('/kokeny/felmentes_rogzites',
          formData,
					{
						headers: {
								'Content-Type': 'multipart/form-data'
						}
					}).then((response) => {
            console.log(response.data);
            this.exam_vertif_dialog = false
            this.save_result = response.data;
            this.save_result_snackbar = true
            this.qualif_uploading = false
            this.qualification_szu_to_upload = null
            this.qualification_mu_to_upload = null
        }, (error) => {
          this.qualif_uploading = false
          console.log(error.data);
        })
        
      },
      saveUgyfelkapu: async function() {
        await this.gettoken()
        this.$http.post('/kokeny/ugyfelkapu_save', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          course_data_id: this.course_data_id,
          selected_uf_student: this.selected_uf_student
        }).then((response) => {
          this.save_result = response.data['message'];
          this.save_result_snackbar = true;
          if (response.data['result'] == 'success') {
            this.ugyfelkapu_dialog = false;
            this.downloadJellapUrl();
          }
        }, (error) => {
          console.log(error.data);
        })
      },
      validate () {
        if (this.$refs.diak_jellap_form.validate()) {
            this.saveJellapDetails()
            this.jellap_change = true
          }
        },
      validate_felmentes () {
        if (this.$refs.diak_jellap_form.validate()) {
            this.uploadQualification()
            this.jellap_change = true
          }
        },
      resetValidation () {
          this.$refs.diak_jellap_form.resetValidation()
        },
    },
    mounted() {
      this.getJellapDetails()
      this.getCategoryList()
      this.downloadJellapUrl()
      this.downloadStatementUrl()
      this.getDocOffices()
      this.getKorlatozasList()
      this.checkUploadedFile()
      this.getQualifications()
      //this.validate()
    },
    watch: {
      contract_id: function (value) {
          this.getJellapDetails()
          this.downloadJellapUrl()
          this.downloadStatementUrl()
          this.checkUploadedFile()
          this.getQualifications()
          //this.validate()
      },
      course_id: function (value) {
          this.getJellapDetails()
          this.downloadJellapUrl()
          this.downloadStatementUrl()
      },
      driving_exam_cert_category: function (value) {
        if (value != '') {
          this.exam_cert = true
        } else {
          this.exam_cert = false
        }
      },
      exam_cert: function (value) {
        if (value != true) {
          this.driving_exam_cert_category = ''
          this.driving_exam_cert_number = ''
          this.exam_cert_date = ''
        }
      },
      second_question: function (value) {
        if (value != true) {
          this.second_categories = null
          this.second_start_date = null
          this.second_end_date = null
        }
      },
      third_question: function (value) {
        if (value != true) {
          this.third_start_date = null
          this.third_end_date = null
        }
      },
      eighth_question: function (value) {
        if (value != true) {
          this.eighth_a_question = null
        }
      },
    },
    computed: {
    ...mapFields([
      'showing.preloader',
      'diakok_details.customer_id',
      'diakok_details.full_name',
      'diakok_details.contract_id',
      'course_details.course_id',
      'course_details.course_student_id',
      'course_details.course_number',
      'course_details.course_data_id',
      'course_details.nkh_course_type_id',
      'auth.admin',
      'course_details.training_type',
  ]),
  },
  }
</script>

<style lang="css">
</style>
